import { render, staticRenderFns } from "./RewardMessage.vue?vue&type=template&id=4896bd97&scoped=true&"
import script from "./RewardMessage.vue?vue&type=script&lang=js&"
export * from "./RewardMessage.vue?vue&type=script&lang=js&"
import style0 from "./RewardMessage.vue?vue&type=style&index=0&id=4896bd97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4896bd97",
  null
  
)

export default component.exports